// -------------------------------------
// Match Height
// -------------------------------------
(function($) {

  jQuery(window).on("load", function() {

    $(window).on("resize", function() {

      // Match Height
      $(".match-height").matchHeight();
      $(".match-height-2").matchHeight();
      $(".match-height-3").matchHeight();

    }).resize();

  });

})(jQuery);